import React from "react";
import A6 from "./index";

const HelloWorld = () => {
  return(
      <>
      <h1>Hello World!</h1>
        <A6/>
      </>
  )
};

export default HelloWorld;

